/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SnapDetailsLineItem = {
    id: number;
    name: string;
    nameScore?: number;
    nameOcrScore?: number;
    sku: string;
    skuScore?: number;
    skuOcrScore?: number;
    quantity: number;
    quantityScore?: number;
    quantityOcrScore?: number;
    total: number;
    totalScore?: number;
    totalOcrScore?: number;
    matchStatus?: SnapDetailsLineItem.matchStatus;
    enrichedName?: string;
};

export namespace SnapDetailsLineItem {

    export enum matchStatus {
        FULL_MATCH = 'FULL_MATCH',
        PARTIAL_MATCH = 'PARTIAL_MATCH',
        MANUAL_MATCH = 'MANUAL_MATCH',
        DELETED = 'DELETED',
    }


}

